import { AlertColor } from '@mui/material/Alert';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../index';

export interface ToastState {
  show: boolean;
  message: string | string[];
  type: AlertColor;
  autoHideDuration: number;
}

const initialState: ToastState = {
  show: false,
  message: '',
  type: 'info',
  autoHideDuration: 6000,
};

export const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: (
      state,
      action: PayloadAction<{
        message: string | string[];
        type?: AlertColor;
        autoHideDuration?: number;
      }>,
    ) => {
      state.show = true;
      state.message = action.payload.message;
      state.type = action.payload.type || 'info';
      state.autoHideDuration = action.payload.autoHideDuration || 6000;
    },
    hideToast: (state) => {
      state.show = false;
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;

export const selectToast = (state: RootState) => state.toast;

export default toastSlice.reducer;
